import { render, staticRenderFns } from "./NavigationItemEditorial.vue?vue&type=template&id=16aa6d8a&"
import script from "./NavigationItemEditorial.vue?vue&type=script&lang=js&"
export * from "./NavigationItemEditorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports